import { RLS_SESSION_KEY_RE, sessionKeyToGucName } from "./rls-session.js";

/** Canonical identity key in every `mapSessionToContext` result (GUC `app.user_id`). */
export const RLS_IDENTITY_CONTEXT_KEY = "userId" as const;

/** Legacy default identity key kept for deployed apps whose policies still use `app.current_user_id`. */
export const RLS_LEGACY_IDENTITY_CONTEXT_KEY = "currentUserId" as const;

/** Mapper return shape: must include {@link RLS_IDENTITY_CONTEXT_KEY}. */
export type RlsSessionContextBase = {
  [RLS_IDENTITY_CONTEXT_KEY]: string;
};

/** Flat session record passed to `createRlsDb` (keys → `app.<snake_case>` GUCs). */
export type RlsSessionContext = Record<string, string>;

export function defaultRlsSessionContext(userId: string): RlsSessionContext {
  return {
    [RLS_IDENTITY_CONTEXT_KEY]: userId,
    [RLS_LEGACY_IDENTITY_CONTEXT_KEY]: userId,
  };
}

export function validateRlsSessionContext(context: RlsSessionContext): void {
  if (!(RLS_IDENTITY_CONTEXT_KEY in context)) {
    throw new Error(
      `[rls] mapSessionToContext must set "${RLS_IDENTITY_CONTEXT_KEY}" (see RLS_IDENTITY_CONTEXT_KEY)`,
    );
  }
  for (const key of Object.keys(context)) {
    if (!RLS_SESSION_KEY_RE.test(key)) {
      throw new Error(
        `[rls] invalid context key "${key}" — use camelCase identifiers (e.g. tenantId, role)`,
      );
    }
    sessionKeyToGucName(key);
  }
}
